import React from "react";

const Home = React.lazy(() => import( './Home/index' /* webpackChunkName:"Home" */ ));
const Test = React.lazy(() => import( './Test/index' /* webpackChunkName:"Test" */ ));
const Rights = React.lazy(() => import( './Home/Rights' /* webpackChunkName:"Rights" */ )); //用户权益页
const ProductList = React.lazy(() => import( './ProductList' /* webpackChunkName:"ProductList" */ ));
const ProductListNew = React.lazy(() => import( './ProductListNew' /* webpackChunkName:"ProductListNew" */ ));
// const NewsInfo = React.lazy(() => import('./Home/NewsInfo' /* webpackChunkName:"NewsInfo" */ ))
const Product = React.lazy(() => import('./Product' /* webpackChunkName:"NewsInfo" */ ))
const Healthy = React.lazy(() => import('./Healthy' /* webpackChunkName:"Healthy" */ ))
const My = React.lazy(() => import('./My' /* webpackChunkName:"Healthy" */ ))
const HealthyPayments = React.lazy(() => import('./HealthPayments' /* webpackChunkName:"HealthPayments" */))

const routers = [
    {
        path: '/home',
        component: Home,
        point: { event_id: '2241951', pageId: 'H1010' },
    },{
        path: '/product',
        component: Product,
    },{
        path: '/test',
        component: Test,
    },{
        path: '/rights',
        component: Rights,
    },{
        path: '/product-list',
        component: ProductListNew,
        point: { event_id: '2241951', pageId: 'H1011' },
    },{
        path: '/healthy/:id',
        component: Healthy,
    },{
        path: '/my',
        component: My,
    }, {
        path: '/healthyPayments',
        component: HealthyPayments,
    }
]

export default routers;

